import * as React from 'react';
import './ReturnsRmaSlide.scss';
import SlideMenu from 'src/components/common/SlideMenu';
import { IRmaModalData, RMA_SUBMIT, RMA_EDIT } from '../../ReturnsView';
import ReturnsRmaTableMobile from './components/ReturnsRmaTableMobile';
import Button from 'src/components/common/Button';
import {
  IReturnDetail,
  IReturnSubmittedOption,
  IReturnEditedOption,
  IStatusFilter,
  IReturnGenerateShippingLabel,
  IReturnGenerateShippingLabelResponse
} from 'src/services/returns/typings';
import hasComma from 'src/utils/hasComma';
import { ERmaStatus } from '../StatusTab/StatusTab';
import i18n from 'src/translation/i18n';
import cartService from 'src/services/cart/CartService';
import locationServiceInstance from 'src/services/location/LocationService';
import ShippingOptions from '../ReturnsCartSlide/components/ShippingOptions';
import DistributionOptions from '../ReturnsCartSlide/components/DistributionOptions';
import BoxInfo from '../ReturnsCartSlide/components/BoxInfo';
import DropOffStore from '../ReturnsCartSlide/components/DropOffStore';
import SelfShipping from '../ReturnsCartSlide/components/SelfShipping';
import BoxConfirm from '../ReturnsCartSlide/components/BoxConfirm';


interface IReturnRmaSlideProps {
  showSlide: boolean;
  closeSlide: () => void;
  rmaModalData: IRmaModalData;

  onSubmitAfterEditRmaList: (
    config: IReturnSubmittedOption,
    callback?: () => void
  ) => void;
  onSaveAfterEditRmaList: (
    config: IReturnEditedOption,
    callback?: () => void
  ) => void;
  handleOpenBarcodeModal: (rmaNumber: string,upsResponseData:any[]) => void;
  typeOfItemStatus: string;
  typeOfItemEligible: string;
  getStatusItems: (body?: IStatusFilter) => void;
  filters: {
    status: string;
    search: any;
  };
  clearStatusFilters: () => void;
  clearEligibleFilters: () => void;
  getRMALists: (body?: IStatusFilter) => void;
  userData:any;
  onGenerateShippingLabel: (
    upsRequest: IReturnGenerateShippingLabel,
    callback?: (resUpsCharges: IReturnGenerateShippingLabelResponse) => void
  ) => void;
}

const ReturnsRmaSlide: React.FC<IReturnRmaSlideProps> = props => {
  const {
    showSlide,
    closeSlide,
    rmaModalData,
    onSubmitAfterEditRmaList,
    onSaveAfterEditRmaList,
    handleOpenBarcodeModal,
    getStatusItems,
    typeOfItemStatus,
    typeOfItemEligible,
    filters,
    clearStatusFilters,
    clearEligibleFilters,
    getRMALists,
    userData,
    onGenerateShippingLabel
  } = props;

  const [poNumber, setPoNumber] = React.useState<string>('');
  const [rmaData, setRmaData] = React.useState<IReturnDetail[]>([]);
  const [deletedItems, setDeletedItems] = React.useState<number[]>([]);
  const [upsResponseData,setupsResponseData]=React.useState([]);
  const [warehouseCodeVal, setWarehouseCode] = React.useState('');
  const [shppingTypeVal,setShippingTypeVal]=React.useState('');
  const [trackingNumbersVal,setTrackingNumbers]=React.useState([]);
  const [selfShippingWarehouseCode, setSelfShippingWarehouseCode] = React.useState('');
  const [distributionSelectedOption, setDistributionSelectedOption] = React.useState('');
  const [shippingTabToShow,setShippingTabToShow]=React.useState(true);
  const [checkShippingOtiopn,setCheckShippingOption]=React.useState(true);
  const [shippingSelectedOption, setShippingSelectedOption] = React.useState('');
  const [tabBackButtonText,setTabBackButtonText]=React.useState('');
  const [shppingType,setShippingType]=React.useState('');
  const [storeList,setStoreList]=React.useState([]);
  const [isLoader,setIsLoader]=React.useState(false);
  const [confirmBox,setConfirmBox]=React.useState(false);
  const [upsTotalShippingCharge,setupsResponseTotal]=React.useState<number>(0);
  const [submitButtonEnabled,setsubmitButtonEnabled]=React.useState<number>(1);
  const [tabTitle,setTabTitle]=React.useState('Shipping Options');
  const [rmaSelected,setRmaSelected]=React.useState('');
  const [preSaveForLaterAlt, setPreSaveForLaterAlt] = React.useState<boolean>(false);
  const [totalItemPrice, setTotalAddedItemPrice] = React.useState<number>(0);
  const [toShippingWarehouseCode, setToShippingWarehouseCode] = React.useState('');
  const [selectedOption, setSelectedOption] = React.useState<string>('');
  const [upsErrorMessage,setUpsErrorMessage]=React.useState('');
  const [shippingLabelRequest, setShippingLabelRequest]=React.useState([]);

  React.useEffect(() => {
    setUpsErrorMessage('');
    setPoNumber(rmaModalData.poNumber ? rmaModalData.poNumber : '');
    setRmaData(rmaModalData.data.length > 0 ? rmaModalData.data : []);
    setDeletedItems([]);
  }, [rmaModalData]);


  React.useEffect(() => {
    /* Calculate total added item price */
    let totalAddedItemPrice=0;
    rmaData.map((res)=>{
      totalAddedItemPrice=totalAddedItemPrice+res.returnAmount;
    });
    setTotalAddedItemPrice(totalAddedItemPrice);
  }, [rmaData]);

  const handleChangePoNumber = (e: any) => {
    if (!hasComma(e.target.value)) {
      setPoNumber(e.target.value);
    }
  };

  const handleChangeRmaData = (id: number) => {
    setRmaData(rmaData.filter(rma => rma.id !== id));
    setDeletedItems([...deletedItems, id]);
  };

  const handleSubmit = () => {
    let selectedWarehouseCode='';
    const upsTrakingNoArr: any=[];
    if(shppingTypeVal==="DROP_OFF_STORE"){
      selectedWarehouseCode=warehouseCodeVal;
    }else if(shppingTypeVal==="SELF_SHIPPING"){
      selectedWarehouseCode=selfShippingWarehouseCode
    }else if(shppingTypeVal==="PREPAID_SHIPPING"){
      generateShippingLabelNow(shippingLabelRequest);
    }
    if(shppingTypeVal!=="PREPAID_SHIPPING"){
    onSubmitAfterEditRmaList(
      {
        type:'',
        poNumber,
        deletedItems,
        rmaNumber: rmaModalData.rmaNumber,
        items:[],
        submissionType: RMA_SUBMIT,
        shippingType:shppingTypeVal,
        warehouseCode:selectedWarehouseCode,
        trackingNumbers:upsTrakingNoArr

      },
      () => {
        clearStatusFilters();
        clearEligibleFilters();
        getStatusItems({
          itemType: typeOfItemStatus === 'part' ? 'PART' : 'CORE'
          // rmaListStatus: filters.status,
          // [filters.search && filters.search.searchBy]: filters.search
          //   ? filters.search.query
          //   : undefined
        });
        getRMALists({
          itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE',
          rmaListStatus: ERmaStatus.NOT_SUBMITTED
        });
        closeSlide();
        handleOpenBarcodeModal(rmaModalData.rmaNumber, []);
      }
    );
  }
  };

  const handleSave = () => {
    onSaveAfterEditRmaList(
      {
        deletedItems,
        items: rmaData,
        poNumber,
        rmaNumber: rmaModalData.rmaNumber
      },
      () => {
        getStatusItems({
          itemType: typeOfItemStatus === 'part' ? 'PART' : 'CORE',
          rmaListStatus: filters.status,
          [filters.search && filters.search.searchBy]: filters.search
            ? filters.search.query
            : undefined
        });
        clearEligibleFilters();
        closeSlide();
      }
    );
  };

  const isDisabledSubmit = (): boolean => {
    const found = rmaData.findIndex(rma => rma.isValid === false);
    const invalidQty = rmaData.findIndex(rma => rma.returnQuantity === 0);
    return rmaData.length === 0 || found !== -1 || invalidQty !== -1 || submitButtonEnabled===1;
  };

  const isDisabledSave = (): boolean => {
    const found = rmaData.findIndex(rma => rma.isValid === false);
    const invalidQty = rmaData.findIndex(rma => rma.returnQuantity === 0);
    return found !== -1 || invalidQty !== -1;
  };

  const handleChangeRmaDataInput = (value: IReturnDetail[]) => {
    setRmaData(value);
  };

  const handleGenerateShippingLabel = (upsBox:any) => {
    setsubmitButtonEnabled(2);
    setShippingLabelRequest(upsBox);
    setShippingTypeVal('PREPAID_SHIPPING');
  }

  /* Generate Shipping Lable */
  const generateShippingLabelNow = (upsBox:any) => {
    const newUpsBoxWithRmaNumber = upsBox.map((item: any, index: any) => {
      upsBox[index].rmaNumber=rmaModalData.rmaNumber;
      return item;
    });
    onGenerateShippingLabel({
      type: selectedOption,
      items: upsBox
    },
    (resUpsCharges: IReturnGenerateShippingLabelResponse) => {
      // Generate Shipping Lable Response
      if (resUpsCharges.message !== null) {
        setConfirmBox(false);
        setIsLoader(false);
        setUpsErrorMessage(resUpsCharges.message);
        closeSlide();
        // handleOpenBarcodeModal(rmaModalData.rmaNumber, []);
      }else{
        setConfirmBox(false);
        const warehouseCodeArr: any=[];
        let selectedWarehouseCode='';
        const upsTrakingNoArr: any=[];
        if(resUpsCharges.shippingLabelExtendedInfo.length>0){
          resUpsCharges.shippingLabelExtendedInfo.map((res)=>{
            if(res.trackingNumber!==""){
            upsTrakingNoArr.push(res.trackingNumber);
            }
            if(res.shipToAddress.warehouseCode!==""){
              warehouseCodeArr.push(res.shipToAddress.warehouseCode);
            }
          });
          // setTrackingNumbers(upsTrakingNoArr);
          // setToShippingWarehouseCode(warehouseCodeArr[0]);
          selectedWarehouseCode=warehouseCodeArr[0];
          }
        onSubmitAfterEditRmaList(
          {
            type:'',
            poNumber,
            deletedItems,
            rmaNumber: rmaModalData.rmaNumber,
            items:[],
            submissionType: RMA_SUBMIT,
            shippingType:shppingTypeVal,
            warehouseCode:selectedWarehouseCode,
            trackingNumbers:upsTrakingNoArr
    
          },
          () => {
            clearStatusFilters();
            clearEligibleFilters();
            getStatusItems({
              itemType: typeOfItemStatus === 'part' ? 'PART' : 'CORE'
              // rmaListStatus: filters.status,
              // [filters.search && filters.search.searchBy]: filters.search
              //   ? filters.search.query
              //   : undefined
            });
            getRMALists({
              itemType: typeOfItemEligible === 'part' ? 'PART' : 'CORE',
              rmaListStatus: ERmaStatus.NOT_SUBMITTED
            });
            
            closeSlide();
          }
        );
        setupsResponseData(resUpsCharges.shippingLabelExtendedInfo);
        handleOpenBarcodeModal(rmaModalData.rmaNumber,resUpsCharges.shippingLabelExtendedInfo);
        setupsResponseTotal(parseFloat(resUpsCharges.total));
        setIsLoader(false);
        setCheckShippingOption(false);
        setShippingSelectedOption('')
        setTabTitle('CONFIRMATION');
        setTabBackButtonText('');
      }
    }
    );
  };

  const getAddresses = async (
    postalCode: string,
    value?: boolean
  ) => {
    const newStoreList: any[] = [];

    newStoreList.push({
      code: '0',
      name: 'Select',
      addr: 'warehouse'
    });

    await locationServiceInstance
      .getLocations(postalCode, value)
      .then(addresses => {
        addresses.forEach((address: any) => {
          newStoreList.push({
            code: address.code,
            name: address.name,
            addr: address.addressLine1
          });
        });
      });

    return newStoreList;
  };

  const getStoreList=async()=>{
    let deliveryAddresses: any[] = [];
    await cartService.getCartShippingAddress().then(async r => {
      deliveryAddresses = await getAddresses(
        r.deliveryLocation.postalCode,
        false
      );
      setStoreList(deliveryAddresses);
      setIsLoader(false);
    });
    
  };

  const handleShippingChangeOption = (e: any) => {
    setShippingSelectedOption(e.target.value);
    
    /* Drop Off at Store Clicked */
    if(e.target.value==="dropOffAtStore"){
      setIsLoader(true);
      setCheckShippingOption(true);
      getStoreList();
      
    }else{
      setCheckShippingOption(false);
      setTabTitle('SHIP TO DISTRIBUTION CENTER ');
      setTabBackButtonText('Back to Shipping Option');
      setShippingType('INDISTRIBUTIONSCREEN');
    }
    
};

const handleDistributionChangeOption = (e: any) => {
  if(e.target.value==="selfShipping"){
    setIsLoader(true);
    getStoreList();
    setWarehouseCode('0');
    setShippingTypeVal('');
    setsubmitButtonEnabled(1);
  }else{
    setSelfShippingWarehouseCode('0');
    setShippingTypeVal('');
    setsubmitButtonEnabled(1);
  }
  setDistributionSelectedOption(e.target.value);
};

const handleBackButtion = () => {
  if(shppingType==="INDISTRIBUTIONSCREEN"){
    /* Back To Shiiping Option */
    setShippingSelectedOption('');
    setDistributionSelectedOption('');
    setCheckShippingOption(true);
    setTabTitle('SHIPPING OPTIONS');
    setTabBackButtonText('');
  }
};

const handleDropOffWarehouse=(dropOffWarehouse:string)=>{
  if(dropOffWarehouse==='0'){
    setsubmitButtonEnabled(1);
  }else{
   setWarehouseCode(dropOffWarehouse);
   setSelfShippingWarehouseCode('0');
   setsubmitButtonEnabled(2);
   setShippingTypeVal('DROP_OFF_STORE');
  }
 }

 // Select Self Shipping warehouse
 const handleSelfShippingWarehouse=(selfSAhippingWarehouseCode:any)=>{
  if(selfSAhippingWarehouseCode==='0'){
    setsubmitButtonEnabled(1);
  }else{
  setSelfShippingWarehouseCode(selfSAhippingWarehouseCode);
  setWarehouseCode('0');
  setsubmitButtonEnabled(2);
  setShippingTypeVal('SELF_SHIPPING');
  }
 }
 const handleConfirmationCancel=()=>{
  setCheckShippingOption(true);
  setShippingSelectedOption('')
  setTabTitle('CONFIRMATION');
  setTabBackButtonText('');
  setShippingSelectedOption('');
  setDistributionSelectedOption('');
  setTabTitle('SHIPPING OPTIONS');
  setTabBackButtonText('');
  setConfirmBox(false);
  setShippingTypeVal('');
  setupsResponseTotal(0);
}

const handleBoxeChange=(e:any)=>{
  if(e===false){
    setsubmitButtonEnabled(1);
  }
}

// UPS confirmation 
const handleUpsConfirmation=()=>{
  setsubmitButtonEnabled(2);
  setSelfShippingWarehouseCode('0');
  setWarehouseCode('0');
  setShippingTypeVal('PREPAID_SHIPPING');
}

  return (
    <SlideMenu
      mounted={showSlide}
      goBackTitle={i18n.t('common.back')}
      level={9999}
      handleCloseMenu={closeSlide}
    >
      <div className="rp-returns-rma-slide">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <h3 className="rp-returns-rma-slide-title">
                {`${
                  rmaModalData.action === RMA_EDIT
                    ? `${i18n.t('common.editActionTxt')}`
                    : ''
                } ${i18n.t('myReturns.returnNo')} ${rmaModalData.rmaNumber}`}
              </h3>
            </div>
          </div>
        </div>

        {showSlide && (
          <ReturnsRmaTableMobile
            rmaData={rmaData}
            rmaDataFixed={rmaModalData.data}
            rmaAction={rmaModalData.action}
            handleChangeRmaData={handleChangeRmaData}
            poNumber={poNumber}
            handleChangePoNumber={handleChangePoNumber}
            handleChangeRmaDataInput={handleChangeRmaDataInput}
            totalShippingCharge={upsTotalShippingCharge}
          />
        )}

        {/* Shipping Options */}
        
        {shippingTabToShow && rmaModalData.action === RMA_SUBMIT  && 
            <div className="return-shipping-row">
              <div className="col">
                <div className="rp-return-details-desktop--tabs-container-rma-slide">
                  <div className="rp-tabs">
                  <div className="rp-return-tabs--tab-rma-slide">
                      <div>{tabTitle}</div>
                      <div className="tab-back-btn-text" onClick={handleBackButtion}>{tabBackButtonText}</div>
                    </div>
                      <div className="rp-tabs--content">
                        <div className="rp-pick-up-tab--info">
                          <div className="return-shipping-container">
                            {checkShippingOtiopn &&  
                              <ShippingOptions
                                shippingSelectedOption={shippingSelectedOption}
                                handleShippingChangeOption={handleShippingChangeOption}
                                rmaSelected={rmaSelected}
                            />
                            }

                            {shippingSelectedOption==="shipToDistribution" && 
                              <DistributionOptions
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                            />
                            }

                            {shippingSelectedOption==="dropOffAtStore" && 
                              <DropOffStore
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                                storeList={storeList}
                                isLoading={isLoader}
                                handleDropOffWarehouse={handleDropOffWarehouse}
                              />
                            }



                            {distributionSelectedOption==="purchasePrepaidShipping" && confirmBox===false && 
                              <BoxInfo
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                                handleGenerateShippingLabel={handleGenerateShippingLabel}
                                userData={userData}
                                totalItemPrice={totalItemPrice}
                                upsErrorMessage={upsErrorMessage}
                                isLoader={isLoader}
                                shippingType={shppingTypeVal}
                                handleConfirmationCancel={handleConfirmationCancel}
                                handleBoxeChange={handleBoxeChange}
                              />
                            }

                            {confirmBox && 
                              <BoxConfirm
                                  distributionSelectedOption={distributionSelectedOption}
                                  handleDistributionChangeOption={handleDistributionChangeOption}
                                  rmaSelected={rmaSelected}
                                  handleGenerateShippingLabel={handleGenerateShippingLabel}
                                  boxResponseData={upsResponseData}
                                  totalShippingCharge={upsTotalShippingCharge}
                                  handleConfirmationCancel={handleConfirmationCancel}
                                  handleUpsConfirmation={handleUpsConfirmation}
                                  shippingType={shppingTypeVal}
                                  totalItemPrice={totalItemPrice}
                              />
                            }

                             {distributionSelectedOption==="selfShipping" && 
                              <SelfShipping
                                distributionSelectedOption={distributionSelectedOption}
                                handleDistributionChangeOption={handleDistributionChangeOption}
                                rmaSelected={rmaSelected}
                                storeList={storeList}
                                isLoading={isLoader}
                                handleSelfShippingWarehouse={handleSelfShippingWarehouse}
                              />
                            }
                          
                          </div>
                          
                        </div>
                       
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            }
         
        {/* End Shipping Options */}

        <div className="rp-returns-rma-slide-actions">
          <div className="container-fluid">
            {rmaModalData.action === RMA_SUBMIT ? (
              <div className="row">
                <div className="col-12">
                  <Button
                    action={handleSubmit}
                    buttonClass="rp-returns-rma-slide-button filled"
                    label={i18n.t('myReturns.submitReturn')}
                    textTransform="uppercase"
                    disabled={isDisabledSubmit()}
                  />
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-12">
                  <Button
                    action={handleSave}
                    buttonClass="rp-returns-rma-slide-button filled"
                    label={i18n.t('common.saveChanges')}
                    textTransform="uppercase"
                    disabled={isDisabledSave()}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </SlideMenu>
  );
};

export default ReturnsRmaSlide;
